import Masonry from 'masonry-layout';

if (document.querySelectorAll('.masonry').length) {
  new Masonry('.masonry', {
    itemSelector: '.masonry-item',
    horizontalOrder: true,
    gutter: 0,
  });
}
